import React from "react";
import { FaqsTable } from "../../UI/Faqs/FaqsTable";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";

const Faqs = () => {
  return (
    <div>
      <PanelHead title="Faqs" />
      <PanelBody content={<FaqsTable />} />
    </div>
  );
};

export default Faqs;
